<template>
  <div class="discount-list">
    <div v-for="discount in bulkDiscounts" :key="discount.id" class="discount">
      <div v-if="discount.name" class="discount-name">{{ discount.name }}</div>
      <div v-if="discount.schedule_type != 'always'" class="discount-schedule text-muted">{{ bulkDiscountSchedule(discount) }}</div>
      <div v-for="group in discount.groups" :key="group.id" class="discount-rule" :class="{ indented: discount.name }">
        <div class="discount-category">{{ bulkDiscountTargets(group) }}</div>
        <div class="discount-detail">
          <span class="text-muted">{{ bulkDiscountMinimum(group) }}</span>
          <span class="discount-amount text-success">{{ bulkDiscountValue(group) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bulkDiscountMinimum, bulkDiscountSchedule, bulkDiscountTargets, bulkDiscountValue } from "@/services/bulkDiscounts";

/**
 * The volume-discount list on its own, so every place that shows discounts renders the same rows
 * rather than each carrying a copy.
 */
export default {
  props: {
    bulkDiscounts: { type: Array, required: true },
  },
  methods: {
    bulkDiscountMinimum,
    bulkDiscountSchedule,
    bulkDiscountTargets,
    bulkDiscountValue,
  },
};
</script>

<style scoped lang="scss">
.discount-list {
  padding: 0 0.5rem;
}

// Each discount is its own block, divided from the next.
.discount {
  padding: 0.875rem 0;
  border-bottom: 1px solid #e5e5e5;

  &:last-child {
    border-bottom: none;
  }
}

.discount-name {
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
}

.discount-schedule {
  font-size: 0.8rem;
  margin-top: 0.125rem;
}

.discount-rule {
  padding: 0.375rem 0;

  // Under a named discount, its rules hang off it.
  &.indented {
    margin-top: 0.375rem;
    padding-left: 0.75rem;
    border-left: 2px solid #e5e5e5;
  }
}

.discount-category {
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.125rem;
}

.discount-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.85rem;
}

.discount-amount {
  font-weight: 600;
}
</style>
